export const PAGE_NUMBER = 0;
export const PAGE_SIZE = 5000;
export const DESC = 'DESC';
export const ASC = 'ASC';